import { useRef, useState, useEffect, MutableRefObject } from "react";

import { ResizeObserver } from "resize-observer";

export function useMeasure(): [
  { ref: React.RefObject<HTMLDivElement> },
  { left: number; top: number; width: number; height: number },
] {
  const ref = useRef<HTMLDivElement>(null);
  const [bounds, set] = useState({ left: 0, top: 0, width: 0, height: 0 });
  const [ro] = useState(
    () => new ResizeObserver(([entry]) => set(entry.contentRect)),
  );
  useEffect(() => {
    if (ref.current) ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);
  return [{ ref }, bounds];
}

export default useMeasure;
